
import ImportMenu from "~/assets/images/importMenu.svg";
import FetchMenu from "~/assets/images/fetchMenu.svg";
import GetAssistance from "~/assets/images/getAssistance.svg";
import AddManually from "~/assets/images/addManually.svg";

export default {
  data() {
    return {
      items: [
        {
          image: ImportMenu,
          title: "Import Menu",
          paragraph: `Export your restaurants menu from Zomato, Swiggy, or from your POS system and easily upload it to Foaps and complete the menu uploading quickly <br/>
            Supported file formats: .xlsx, .xltx, .xls, .csv, .ods`,
          buttonText: "Upload Menu",
          buttonAction: () => {
            this.$router.push("/menu/upload");
          }
        },
        // {
        //   image: FetchMenu,
        //   title: "Fetch Menu",
        //   paragraph:
        //     "Import your restaurant menu from Zomato or Swiggy seamlessly from as single click",
        //   buttonText: "Fetch Menu",
        //   buttonAction: () => {}
        // },
        // {
        //   image: GetAssistance,
        //   title: "Get Assistance",
        //   paragraph:
        //     "If you're running out of time and need assistance with menu uploading. Our agent can upload your restaurant menu on your behalf",
        //   buttonText: "Get Support",
        //   buttonAction: () => {
        //     this.$emit("show-menu-assistance-dialog");
        //   }
        // },
        {
          image: AddManually,
          title: "Add Manually",
          paragraph: "Start adding menu items one by one into foaps",
          buttonText: "Add Item",
          buttonAction: () => {
            this.$router.push("/menu/new/item");
          }
        }
      ]
    };
  }
};
